module.exports = __webpack_public_path__ + "static/media/north-carolina.0327217f.jpg";